@if (confirmationWasSuccessfully && pushPdfInfo?.isVisible) {
  <mwe-push-pdf-info-on-confirmation
    [info]="pushPdfInfo"
    [products]="products"
    [address]="address"
    [targetMode]="targetMode"
    (startProcessBtnClicked)="onStartProcessBtnClicked()"
  />
}
